
import ContentHubNavItem from "@components/content_hubs/navigation/content-hub-nav-item.vue";
import { apiService } from "@services/api.service";
import { computed, defineComponent, onMounted, Ref, ref } from "vue";
import { ViewportStoreModule } from "@stores/viewport.store";
import { getModule } from "vuex-module-decorators";

const ViewportStore = getModule(ViewportStoreModule);

export default defineComponent({
  name: "ContentHubNavMenu",
  components: {
    ContentHubNavItem,
  },
  setup() {
    const contentRoutes: Ref<ContentHubs.NavItem[]> = ref([]);
    const getContentRoutes = async () => {
      try {
        const response = await apiService.contentHubs.getActiveContentRoutes(false);
        contentRoutes.value = response.data.content_routes;
      } catch (errors) {
        apiService.handleAPIError(errors);
      }
    };

    const expanded = ref(false);
    const toggleMobileMenu = () => {
      expanded.value = !expanded.value;

      const { body } = document;
      if (expanded.value) body.scrollTop = document.documentElement.scrollTop = 0;
      body.style.overflow = expanded.value ? "hidden" : "auto";
    };
    const mobileMode = computed(() => ["xs", "sm", "md"].includes(ViewportStore.currentViewport));

    onMounted(() => {
      getContentRoutes();
    });

    return {
      expanded,
      toggleMobileMenu,
      contentRoutes,
      mobileMode,
    };
  },
});
